module.exports = __webpack_public_path__ + "3c2ebaadacc3cc56dabd98b4735c082c.svg";